import { useToast } from "@chakra-ui/react";
import { parsedOption } from "helpers/parsed/parsedOption";
import { IGeneralContext } from "Interfaces/Providers/General";
import {
  createContext,
  ReactNode,
  useCallback,
  useEffect,
  useState,
} from "react";
import storeService from "services/storeService";
import { useImmer } from "use-immer";
import { appConfig } from "env-config";
import storeServiceSupplier from "services/Supplier/storeServiceSupplier";
import { useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

interface Auth0ProviderProps {
  children: ReactNode;
}

const GeneralProvider = ({ children }: Auth0ProviderProps) => {
  let location = useLocation();

  const path = location.pathname;

  const partesDoCaminho = path.split("/");
  const { user } = useAuth0();

  const textPathActive = partesDoCaminho[1];
  const [isFirstRender, serFirsrtRender] = useState(true);
  const [loading, setLoading] = useState(false);
  const [sideBarCollapse, setSideBarCollapse] = useState(
    Boolean(JSON.parse(localStorage.getItem("sidebarCollapse") || "false")) ||
      false
  );
  const [error, setError] = useState("");
  const [store, setStore] = useState(
    localStorage.getItem("storeUser") || {
      label: "1500 - CD Barueri",
      value: 1500,
    }
  );

  const [data, updateData] = useImmer<any[]>([]);

  const handleStore = useCallback(async (store: any) => {
    setStore(store);
    localStorage.setItem("storeUser", JSON.stringify(store));
    window.location.reload();
  }, []);
  const getData = useCallback(async () => {
    setLoading(true);
    serFirsrtRender(false);
    user.sub.split("|")[0] === "waad"
      ? storeService
          .getStore()
          .then((response) => {
            updateData(parsedOption(response.data?.data));
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          })
      : storeServiceSupplier
          .getStore()
          .then((response) => {
            updateData(parsedOption(response.data?.data));
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
  }, [updateData]);

  useEffect(() => {
    if (localStorage.getItem("storeUser")) {
      setStore(JSON.parse(localStorage.getItem("storeUser")));
    } else {
      localStorage.setItem(
        "storeUser",
        JSON.stringify({
          label: "1500 - CD Barueri",
          value: 1500,
        })
      );

      setStore({
        label: "1500 - CD Barueri",
        value: 1500,
      });
    }
  }, []);

  const handleSidebarCollapse = useCallback(async () => {
    localStorage.setItem("sidebarCollapse", JSON.stringify(!sideBarCollapse));

    setSideBarCollapse(!sideBarCollapse);
  }, [sideBarCollapse]);

  return (
    <GeneralContext.Provider
      value={{
        error,
        setStore,
        loading,
        data,
        sideBarCollapse,
        handleStore,
        handleSidebarCollapse,
        store, //
        isFirstRender,
        getData,
      }}
    >
      {children}
    </GeneralContext.Provider>
  );
};

export default GeneralProvider;
export const GeneralContext = createContext<IGeneralContext>(
  {} as IGeneralContext
);
